// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Price_wrap__3-xY9","price":"Price_price__3SKWJ","icon":"Price_icon__uYbR6","text":"Price_text__1uwLU"};